import { render, staticRenderFns } from "./TpvTable.vue?vue&type=template&id=01b8a730&scoped=true&lang=pug&"
import script from "./TpvTable.vue?vue&type=script&lang=js&"
export * from "./TpvTable.vue?vue&type=script&lang=js&"
import style0 from "./TpvTable.vue?vue&type=style&index=0&id=01b8a730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b8a730",
  null
  
)

export default component.exports